import React, {forwardRef} from 'react'
import PropTypes from 'prop-types'
import {Flex, Text} from '@chakra-ui/react'

const HeadingSection = forwardRef(({title, description, styles = {}}, ref) => {
    return (
        <Flex {...styles.headingSection} ref={ref} data-testid="heading-section">
            <Text {...styles.headingTitle}>{title}</Text>
            <Text {...styles.headingSubtitle}>{description}</Text>
        </Flex>
    )
})

HeadingSection.displayName = 'HeadingSection'
HeadingSection.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    styles: PropTypes.object,
}

export default HeadingSection
